import {QuantityTypeTemplateQuestion} from "./QuantityTypeTemplateQuestion";

export class QuantityTypeTemplate {
  constructor(
    public readonly id: string,
    public readonly order: number,
    public readonly description: string,
    public readonly shouldGenerateWorkorder: boolean,
    public readonly questions: QuantityTypeTemplateQuestion[],
    public readonly archivedAt: Date|null,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }

  static fromJson(json: any): QuantityTypeTemplate {
    return new QuantityTypeTemplate(
      json['id'],
      json['order'],
      json['description'],
      json['should_generate_workorder'],
      (json['question_set'] ?? []).map((q: any) => QuantityTypeTemplateQuestion.fromJson(q)),
      json['archived_at'] ? new Date(json['archived_at']) : null,
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}